import delay from "@flixbus-phx/marketplace-common/src/helper/delay/delay";
import {
  fetchData,
  getFileName,
  getFileUrl,
  startDownload,
} from "../../../shared/helpers/downloadFileViaRest/downloadFileViaRest";
import { BookingInformationConfiguration, QueryFindBookingsArgs } from "../../../shared/types/schema";

export type DownloadBookingInfoFieldConfigurationParameter = {
  bookingInformation: BookingInformationConfiguration["bookingInformation"];
  tripInformation: BookingInformationConfiguration["tripInformation"];
  passengerInformation: BookingInformationConfiguration["passengerInformation"];
};

const downloadBookingInfo = async (
  findBookingsQueryArgs: QueryFindBookingsArgs,
  fieldConfiguration: DownloadBookingInfoFieldConfigurationParameter,
  signal?: AbortSignal
) => {
  try {
    const response = await fetchData(
      "/bookings",
      {
        ...findBookingsQueryArgs,
        fieldConfiguration: {
          ...fieldConfiguration,
        },
      },
      signal
    );

    if (response.status === 202) {
      await delay(5000);

      if (signal?.aborted === true) {
        return undefined;
      }
      return downloadBookingInfo(findBookingsQueryArgs, fieldConfiguration, signal);
    }

    const fileName = getFileName(response);
    const fileUrl = await getFileUrl(response);

    startDownload(fileName, fileUrl);

    return undefined;
  } catch (error) {
    if (error instanceof DOMException && error.name == "AbortError") {
      return undefined;
    }
    return error;
  }
};

export default downloadBookingInfo;
